import classnames from 'classnames';

import styles from './ArticleStatusBar.module.scss';

type ArticleStatusBarProps = {
  isInternal: boolean;
};
export function ArticleStatusBar({
  isInternal,
}: ArticleStatusBarProps): JSX.Element {
  const rootClass = classnames(styles.root, {
    [styles.internal]: isInternal,
  });

  return <div className={rootClass} />;
}
